import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { DragulaService } from 'ng2-dragula';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-liste-cap',
    templateUrl: './liste-cap.component.html',
    styleUrls: ['./liste-cap.component.css'],
    standalone: false
})
export class ListeCapComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() isDND: Boolean;
  @Output() show = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  listChantier = [];
  listeAgence = [];
  listeSite = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isHisto: Boolean = false;
  checkedall: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  focusIndex = 0;
  listCAP = [];
  societe = {};
  error = '';
  formatPerso = [];
  formatprs: String = '';

  @ViewChild('msg') msg;
  @ViewChild('format') format;
  constructor(public common: CommonService, private modalService: BsModalService, private dragulaService: DragulaService) {
    this.societe = this.common.local.getObject('paramSociete') || {};
  }

  ngOnInit() {
    this.getListCAP().then(data => {
      this.isEmpty = false;
    });
  }

  getpays(id) {
    let elt;
    this.common.getType('typePays').forEach(elem => {
      if (elem.id === id) {
        elt = elem;
      }
    });
    return elt;
  }

  parseDate() {
    this.listCAP.forEach(elt => {
      // elt.datefilter = this.common.parseDate(elt.dateEmission);
      elt.dateEmission = moment(elt.dateEmission, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      elt.dateFilter = this.common.parseDate(elt.dateEmission);
    });
    this.listCAP = [... this.listCAP] 
    
  }

  hide() {
    this.show.emit();
  }


  showHisto() {
    this.isHisto = !this.isHisto;
    this.listCAP = [];
    this.selected = [];
    this.getListCAP();
  }


  getListCAP() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBGetListCAP',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': [['DBGetListCAP'], this.detail, {
        'typeParam': 'boolean',
        'valeur': !this.isHisto
      }]
    };

    if (this.isDND) {
      param.data[3] = 'DND';
    }

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.listCAP = [... datas.data || []] 
      this.parseDate()
      return datas.data;
    });
  }

  selectRow(row) {
    this.focusIndex = this.listCAP.indexOf(row);
    this.selected = [row];
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  calculMontant(row) {
    if (row.qte && row.tarif) {
      row.prixHT = row.qte * row.tarif;
    } else {
      row.prixHT = 0;
    }
  }

  getLibelleContenant(elt) {
    if (elt) {
      elt.libelleObjetEntite = (elt.famille ? elt.famille.libelle + ' ' : '') + (elt.cubage ? elt.cubage.cubage + ' ' : '') +
        (elt.uniteCont ? elt.uniteCont.libelle : '');
    }
  }

  checkedAll(event) {
    this.listCAP.forEach(elt => {
      elt.isChecked = this.checkedall;
      this.checkedRow(elt);
    });
  }

  checkedRow(selected) {
    if (selected.isChecked) {
      this.selected.push(selected);
    } else {
      this.selected.splice(this.selected.indexOf(selected), 1);
    }
  }

  getFormatperso() {
    console.log(this.selected);
    const param = {
      'servlet': 'DBGestionFormatParametrable',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_TYPE_FORMAT': {
          'typeParam': 'int',
          'valeur': 30
        },
        'LES_DEUX_LISTES': {
          'typeParam': 'boolean',
          'valeur': false
        }
      }
    };
    if (!this.selected.length) {
      this.error = 'Veuillez choisir au moins une ligne de CAP.';
      this.common.openModal(this.modalService, this.msg);
    } else {
      this.common.post('', { param: param }).then(datas => {
        this.formatPerso = datas.data;
        if (this.formatPerso.length > 1) {
          this.formatprs = this.formatPerso[0];
          // open modal
          this.common.openModal(this.modalService, this.format);
        } else {
          if (this.formatPerso.length === 1) {
            this.formatprs = this.formatPerso[0];
            this.printSelected();
          } else {
            this.common.openModal(this.modalService, this.format);
          }
        }
      });
    }
  }

  printSelected() {
    const listClefCAPAImprimer = [];
    this.selected.forEach(elt => {
       if (!listClefCAPAImprimer.includes('' + elt.id)) {
           listClefCAPAImprimer.push('' + elt.id);
       }
    });
    
    this.printCAP(listClefCAPAImprimer).then(datas => {
      if (datas.data && datas.data.length) {
        this.common.closeModal();
        datas.data.forEach(elt => {
            this.common.openFile(elt);
            this.common.closeModal();
        });
      }
    }).catch(error => {
      this.common.closeModal();
      this.error = error;
      this.common.openModal(this.modalService, this.msg);
      console.log(error);
    });    
          
    /*
    const prom = [];
    this.selected.forEach(elt => {
      const fct = this.printCAP(elt);
      prom.push(fct);
    });

    Promise.all(prom).then(data => {
      if (data.length) {
        this.common.closeModal();
        data.forEach(elt => {
          if (elt.data) {
            if (elt.data[0]) {
              this.common.openFile(elt.data[0]);
              this.common.closeModal();
            }
          }
        });
      }
    }).catch(error => {
      this.common.closeModal();
      this.error = error;
      this.common.openModal(this.modalService, this.msg);
      console.log(error);
    });
    */
  }

  printCAP(listClefCAPAImprimer) {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBImprimerCAP',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'LIST_CLEF_CAP': listClefCAPAImprimer,
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_FORMAT_PARAMETRABLE': {
          'typeParam': 'int',
          'valeur': this.formatprs['id']
        },
      }
    };

    if (this.isDND) {
      param.data['DND'] = {
        'typeParam': 'boolean',
        'valeur': true
      };
    }

    return this.common.post('', { param: param }, true).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.message) {
          return Promise.reject(datas.message);
        } else {
          return datas;
        }
      }
    });
  }

  exportXLS() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': 'DBExtraireCAPClientXLS',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 2
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'IS_HISTO': {
          'typeParam': 'boolean',
          'valeur': this.isHisto
        },
        'IS_DND': {
          'typeParam': 'boolean',
          'valeur': this.isDND || false 
        },        
      }
    };

  
    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }
}
